var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "top",
      "label-width": "100px",
      size: "mini"
    }
  }, [_c("div", {
    staticClass: "form-in-line"
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      prop: "n01Code",
      label: "类型编码"
    }
  }, [_c("cpsc-form-select-code-input", {
    attrs: {
      disabled: !!_vm.id,
      "default-selected": _vm.prepend,
      placeholder: "请指定4位类型编码",
      maxlength: 4,
      options: _vm.options
    },
    on: {
      change: _vm.getPrepend
    },
    model: {
      value: _vm.form.n01Code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n01Code", $$v);
      },
      expression: "form.n01Code"
    }
  })], 1), _c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "是否生效"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-color": "#13ce66"
    },
    model: {
      value: _vm.form.disabled,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "disabled", $$v);
      },
      expression: "form.disabled"
    }
  })], 1)], 1), _c("div", {
    staticClass: "form-in-line"
  }, [_c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "业务名称",
      prop: "n01Name"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入业务名称"
    },
    model: {
      value: _vm.form.n01Name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n01Name", $$v);
      },
      expression: "form.n01Name"
    }
  })], 1), _c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "风险等级",
      prop: "n01Risk"
    }
  }, [_c("cpsc-select", {
    attrs: {
      placeholder: "请选择风险等级"
    },
    model: {
      value: _vm.form.n01Risk,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n01Risk", $$v);
      },
      expression: "form.n01Risk"
    }
  }, [_c("el-option", {
    attrs: {
      label: "A类",
      value: "A"
    }
  }), _c("el-option", {
    attrs: {
      label: "B类",
      value: "B"
    }
  }), _c("el-option", {
    attrs: {
      label: "C类",
      value: "C"
    }
  }), _c("el-option", {
    attrs: {
      label: "D类",
      value: "D"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "风险描述",
      prop: "n01RiskExplain"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 1,
      maxlength: "1000",
      "show-word-limit": "",
      placeholder: "请输入风险描述"
    },
    model: {
      value: _vm.form.n01RiskExplain,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n01RiskExplain", $$v);
      },
      expression: "form.n01RiskExplain"
    }
  })], 1), _c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "业务标签",
      prop: "n01Tag"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入业务标签"
    },
    model: {
      value: _vm.form.n01Tag,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n01Tag", $$v);
      },
      expression: "form.n01Tag"
    }
  })], 1), _c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "业务描述"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5,
      maxlength: "1000",
      "show-word-limit": "",
      placeholder: "请输入业务描述"
    },
    model: {
      value: _vm.form.n01Describe,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n01Describe", $$v);
      },
      expression: "form.n01Describe"
    }
  })], 1), _c("el-form-item", {
    staticClass: "form-in-line-item",
    attrs: {
      label: "备注说明"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5,
      maxlength: "1000",
      "show-word-limit": "",
      placeholder: "请输入备注说明"
    },
    model: {
      value: _vm.form.n01Remark,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "n01Remark", $$v);
      },
      expression: "form.n01Remark"
    }
  })], 1), _c("el-form-item", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")]), !_vm.onlyReady ? _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };